﻿import { Component, HostBinding, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Ng2SmartTableModule, LocalDataSource, ViewCell } from 'ng2-smart-table';

@Component({
    
    template: `
  <div class="wr-expanded-sale-container">
    <div class="col-xs-10 wr-expanded-sale-details">
        <ul class="wr-expanded-sale-summary-section clearfix">
            <li class="wr-expanded-sale-line-item" *ngFor='let row of rowData.Details; let i = index'>
                <div class="wr-expanded-sale-line-item-row">
                    <div class="col-xs-6 wr-expanded-sale-line-item-description">
                        <div class="wr-expanded-sale-line-item-quantity">{{i+1}}</div>
                        <div class="wr-expanded-sale-line-item-name" [innerHtml]="row.Ten"></div>
                    </div>
                    <div class="col-xs-2 wr-expanded-sale-line-item-unit-price-details">
                        <div class="wr-expanded-sale-line-item-unit-price">
                            {{row.SoLuong | number}}
                        </div>
                    </div>
                    <div class="col-xs-2 wr-expanded-sale-line-item-unit-price-details">
                        <div class="wr-expanded-sale-line-item-unit-price">
                            {{row.DonGia | number}}
                        </div>
                    </div>
                    <div class="col-xs-2 wr-expanded-sale-line-item-total">
                        <span vd-align="right" class="wr-li-cell-summary-price-value vd-align-right">
                            {{row.ThanhTien | number}}
                        </span>
                    </div>
                </div>               
            </li>
        </ul>

        <div class="wr-expanded-sale-summary">
            <div class="col-xs-6 wr-expanded-sale-note">
                <div class="wr-expanded-sale-label--bold"></div>
                <div class="wr-expanded-sale-note-content">
                    <span class="wr-honour-line-breaks"></span>
                </div>
            </div>

            <ul class="col-xs-6">
                <li class="wr-expanded-sale-summary-section">

                    <div class="wr-expanded-sale-totals-line" >
                        <div>Tiền hàng</div>
                        <div>{{rowData.TienHang | number}}</div>
                    </div>                  
                    <div class="wr-expanded-sale-totals-line" >
                        <div>Giảm giá</div>
                        <div>{{(rowData.GiamGia + rowData.DiemTien) | number}}</div>
                    </div> 
                    <div class="wr-expanded-sale-totals-line" >
                        <div>Thẻ giảm giá</div>
                        <div>{{rowData.GiamVoucher | number}}</div>
                    </div> 
                   <div class="wr-expanded-sale-totals-line" >
                        <div>Tiền thuế</div>
                        <div>{{rowData.SoTienThue | number}}</div>
                    </div>
                </li>
                <li class="wr-expanded-sale-summary-section wr-expanded-sale-totals-line">
                    <div class="wr-expanded-sale-total-label wr-expanded-sale-label--bold">Tổng</div>
                    <div class="wr-expanded-sale-label--bold">
                        {{rowData.TongTien | number}}
                    </div>
                </li>               
            </ul>
        </div>
    </div>
    <div class="col-xs-2 wr-expanded-sale-actions">
       
        <div class="wr-expanded-sale-actions-buttons vd-button-group">           
            <button ng-transclude=""  role="button" (click)="onDeleteClick()" class="vd-button vd-button--text vd-button--secondary">
                <i class="fa fa-trash vd-mrm"></i><span>
                    Xóa hóa đơn
                </span>
            </button>
            <button ng-transclude="" role="button" (click)="onPrintClick()" class="vd-button vd-button--text vd-button--secondary" >
                <i class="fa fa-print vd-mrm"></i><span>
                    In Hóa Đơn
                </span>
            </button>
        </div>
    </div>
</div>
  `,
})
export class RowExpandViewComponent implements ViewCell, OnInit {
    //[disabled] = "rowData.TinhTrang == 1"
    renderValue: string;

    @Input() value: string | number;
    @Input() rowData: any;

    @Output() print: EventEmitter<any> = new EventEmitter();
    @Output() del: EventEmitter<any> = new EventEmitter();

    ngOnInit() {
        this.renderValue = this.value.toString().toUpperCase();
    }

    onPrintClick() {
        this.print.emit(this.rowData);
    }
    onDeleteClick() {
        this.del.emit(this.rowData);
    }
}